import { html, LitElement, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { styleMap } from "lit/directives/style-map.js";

import { presentVideo } from "..";
import { type Video } from "./bible-video-player-overlay";
import css from "./bible-video-play-button.css?inline";

@customElement("bible-video-play-button")
export class VideoPlayButtonElement extends LitElement {
  static styles = unsafeCSS(css);

  private refs = {
    button: createRef<HTMLButtonElement>(),
  };

  @property()
  size: "default" | "small" | null = null!;

  @property()
  video: Video = null!;

  render() {
    return html`
      <button
        ${ref(this.refs.button)}
        part="bible-video-play-button"
        @click=${() => {
          presentVideo({
            video: this.video,
            trigger: this.refs.button.value!,
          });
        }}
        aria-label="${`Play ${this.video.title}`}"
        style=${styleMap({
          "--size": this.size === "small" ? "44px" : "64px",
        })}
      >
        <span class="icon" part="bible-video-play-circle"></span>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bible-video-play-button": VideoPlayButtonElement;
  }
}
